import script from "./TrainingPlanTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingPlanTable.vue?vue&type=script&setup=true&lang=js"

import "./TrainingPlanTable.vue?vue&type=style&index=0&id=dc99a39c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc99a39c"]])

export default __exports__